import { getQuoteMarketKey } from "@core/utils/getCurrencyMeta";

const handleOrderScale = (value, orderScaleMap, coin) => {
  let orderScale = 0;
  if (value) {
    if (orderScaleMap !== null && orderScaleMap !== undefined) {
      const val = Object.keys(orderScaleMap);
      val.map((item) => {
        if (item === coin) {
          const scale = orderScaleMap[item];
          orderScale = value.toFixed(scale);
        }
      });
    }
  }
  return orderScale;
};
const handlePriceScale = (value, priceScale, coin) => {
  let scalePrice = 0;
  const currencyMarket = getQuoteMarketKey(coin, "IRT");
  if (value) {
    if (priceScale !== null && priceScale !== undefined) {
      const val = Object.keys(priceScale);
      val.map((item) => {
        if (item === currencyMarket) {
          const scale = priceScale[item];
          scalePrice = value.toFixed(scale);
        }
      });
    }
  }
  return scalePrice;
};

const returnCurrencyScale = (orderScaleMap, currency) => {
  let scale = 0;
  if (!!orderScaleMap) {
    Object.keys(orderScaleMap).map((item) => {
      if (item === currency) {
        scale = orderScaleMap[item];
      }
    });
  }
  return scale;
};

const returnMarketScale = (priceScale, currencyMarket) => {
  let scale = 0;
  if (!!priceScale) {
    Object.keys(priceScale).map((item) => {
      if (item === currencyMarket) {
        scale = priceScale[item];
      }
    });
  }
  return scale;
};
export {
  handleOrderScale,
  handlePriceScale,
  returnCurrencyScale,
  returnMarketScale,
};
